/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// import ProductCard from "../ProductCard";
import MenuCart from "../Menu/MenuCart";
import { axiosInstance } from "../utils/axiosInstance";
import Loader from "../Loader";
import ShareSocialModal from "../ShareSocialModal";
import { useNavigate } from "react-router-dom";

export default function PopularFood({
  filterCategory,
  category,
  setFilterCategory,
}) {
  const [produceData, setProductData] = useState([]);
  const [loader, setloader] = useState(false);
  const navigate = useNavigate();
  const getAllProduct = async () => {
    setloader(true);
    try {
      await axiosInstance.get("user/product").then((response) => {
        if (response?.data?.status === true) {
          setloader(false);
          setProductData(response?.data?.products);
        }
      });
    } catch (error) {
      setloader(false);
    }
  };

  const searchByCategory = async (typeo) => {
    try {
      await axiosInstance
        .get("user/product", {
          params: { category_id: typeo },
        })
        .then((response) => {
          if (response.data.status === true) {
            setProductData(response?.data?.products);
          }
        });
    } catch (error) {}
  };

  useEffect(() => {
    if (filterCategory?.products?.length > 0) {
      setProductData(filterCategory?.products);
    } else {
      getAllProduct();
    }
  }, [filterCategory]);

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  // const handleShow = () => setShowModal(true);
  const [url, setUrl] = useState("");
  return (
    <>
      <section className="menu  mt_95 xs_mt_65">
        <div className="container">
          <div className="row">
            <div
              className="col-xl-6 col-lg-6 wow fadeInUp"
              data-wow-duration="1s"
            >
              <div className="section_heading mb_25">
                <h4>food Menu</h4>
                <h2>Delicious Foods</h2>
              </div>
            </div>
            <div
              className="col-xl-6 col-lg-6 wow fadeInUp"
              data-wow-duration="1s"
            >
              <div className="menu_filter align-items-center gap-2 d-flex flex-wrap">
                <button onClick={getAllProduct} className={"active font-20"}>
                  all menu
                </button>
                <select
                  onChange={(e) => searchByCategory(e.target.value)}
                  className="w-50 font-20"
                  style={{ background: "#cd2128", color: "#fff" }}
                >
                  {category?.map((e, i) => (
                    <option value={e?.id}>{e?.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {loader ? (
            <Loader />
          ) : (
            <>
              <div className="row grid h-100">
                {produceData?.length < 1 ? (
                  <h3 className="ps-3">No Data Found...</h3>
                ) : (
                  produceData
                    ?.slice(0, 8)
                    .map((productDatas, i) => (
                      <MenuCart
                        setShowModal={setShowModal}
                        setUrl={setUrl}
                        productData={productDatas}
                      />
                    ))
                )}
                {produceData?.length > 8 && (
                  <button
                    onClick={() => navigate(`/menu`)}
                    style={{ width: "fit-content" }}
                    className="common_btn ms-auto mt-4 mx-auto"
                  >
                    View All Menu
                  </button>
                )}
              </div>
            </>
          )}
        </div>
        <ShareSocialModal
          showModal={showModal}
          handleClose={handleClose}
          url={url}
        />
      </section>
    </>
  );
}
